import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    queue: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const masterBlasterReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MASTERBLASTER_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MASTERBLASTER_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MASTERBLASTER_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.MASTERBLASTER_RESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default masterBlasterReducer;
